import type { PolygonStyle } from 'fifa-gis-library'

export function leafletToMapboxGeoFenceStyle(
  styles: Partial<PolygonStyle & { textColor?: string }>,
) {
  return {
    fill: {
      paint: {
        'fill-color': styles.fillColor,
        'fill-opacity': styles.fillOpacity,
      },
    },
    stroke: {
      paint: {
        'line-color': styles.strokeColor,
        'line-opacity': styles.strokeOpacity,
        'line-width': styles.strokeWeight,
      },
    },
    symbol: {
      paint: {
        'text-color': styles.textColor || styles.strokeColor,
      },
    },
  }
}
